import { useEffect, useState } from "react";

const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#new", label: "新番速递" },
  { href: "#top", label: "高分榜" },
  { href: "#category", label: "主题分类" },
  { href: "#review", label: "最新评测" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/90 backdrop-blur-md border-b border-background-800/60"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sailboat-line text-lg" />
          </span>
          <span className="font-heading text-xl text-foreground-50">漫镜</span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-foreground-300 transition-colors hover:text-primary-300 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-300 transition-colors hover:border-primary-400 hover:text-primary-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line text-sm" />
          </button>
          <a
            href="#review"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            看本周榜单
          </a>
        </div>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-700 text-foreground-200 md:hidden whitespace-nowrap cursor-pointer"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-800/60 bg-background-950/95 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-300 transition-colors hover:bg-background-800 hover:text-primary-300"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#review"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm text-background-50"
            >
              看本周榜单
            </a>
          </div>
        </div>
      )}
    </header>
  );
}